// extracted by mini-css-extract-plugin
export default {"tabsHeader":"RulesTabs_tabsHeader__9NmJG","tabsContent":"RulesTabs_tabsContent__fEGU3","tabContent":"RulesTabs_tabContent__HqJHo"};